import React from 'react';
import styled from 'styled-components';
import { InputErrors } from './WithErrors';

type Props = {
  className?: string;
  checked?: boolean;
  setChecked?: (checked: boolean) => void;
  errors?: string[];
} & React.InputHTMLAttributes<HTMLInputElement>;

const Radio = ({ checked = false, setChecked, className = '', errors, ...rest }: Props) => (
  <InputErrors errors={errors}>
    <input
      type="radio"
      className={className}
      checked={checked}
      onChange={(e) => setChecked?.(e.target.checked)}
      {...rest}
    />
  </InputErrors>
);

export default styled(Radio)``;
